export const eventPlayer = (playerName, 
                            playerSurname, 
                            shirtnumber = '',
                            optionalClass = '',
                            playerImgUrl='https://m.netinfo.bg/gong/images/player_of_the_match/player_default.png' ) => `
<div class="player-item ${optionalClass}"">
    <div class="player-image">
        <img width="96" height="96" src="${playerImgUrl}" alt="${playerName} ${playerSurname}">
        <span class="player-number">${shirtnumber}</span>
    </div>
    <div class="player-name">
        <span class="name">${playerName}</span>
        <span class="surname">${playerSurname}</span>
    </div>
</div>`;